import React, { useEffect, useState } from "react";
import ShowProject from "../ShowProject/ShowProject";

const SingleProject = () => {
  const [projects, setProjects] = useState([]);

  const fetchData = async () => {
    try {
      await fetch("./Data.json")
        .then((response) => response.json())
        .then((data) => setProjects(data.projects));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {projects.map((project) => (
        <ShowProject project={project} key={project.id} />
      ))}
    </>
  );
};

export default SingleProject;
